/**
 * Stable category-list tracking key for ProductList.
 * Uses URL page/limit (intent), not server-filled pagination state, so a single
 * fetch that updates itemsPerPage from the response cannot re-fire list events.
 */
export function buildCategoryListTrackingKey({
  listId,
  page,
  limit,
  search,
  sortOption
} = {}) {
  const resolvedPage = Number.isFinite(Number(page)) && Number(page) > 0 ? Number(page) : 1;
  const resolvedLimit = Number.isFinite(Number(limit)) && Number(limit) > 0 ? Number(limit) : 24;
  return [
    String(listId || ''),
    resolvedPage,
    resolvedLimit,
    String(search || ''),
    String(sortOption || '')
  ].join('|');
}

export function shouldTrackCategoryList(lastKey, nextKey) {
  return Boolean(nextKey) && lastKey !== nextKey;
}
